const IS_DEV = process.env.NODE_ENV === 'development'

const IS_UAT = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'main'

const IS_DEMO = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'demo'

const IS_PROD = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'production'

const IS_LOCAL =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF == null &&
  process.env.NODE_ENV === 'production'

const IS_PREVIEW =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF != null &&
  !IS_UAT &&
  !IS_DEMO &&
  !IS_PROD

const IS_TEST = process.env.NODE_ENV === 'test'

// "For Dev Eyes Only" 😆
const IS_FDEO = !IS_PROD && !IS_DEMO

const ENV = {
  IS_DEMO,
  IS_DEV,
  IS_FDEO,
  IS_LOCAL,
  IS_PREVIEW,
  IS_PROD,
  IS_TEST,
  IS_UAT,
}

// TODO: Perhaps relocate anywhere we use `globalThis` into this file
// to consolidate where we are trying to determine environment questions?
export const origin = globalThis?.location?.origin

export default ENV
